module.exports = __webpack_public_path__ + "static/media/disneyplus-logo.e778b6ec.jpg";